import { Button } from 'components';
import styles from './CloseButton.module.scss'

type Props = {
    onClick?: () => void
};

const CloseButton = ({ onClick }: Props) => (
    <Button
        className={styles.button}
        icon="close"
        fillMode="flat"
        themeColor="primary"
        onClick={onClick}
    />
);

export default CloseButton;